import React, { Suspense } from 'react';
import Ramen from '@team_yumi/ramen';
import PageLoader from './Fallback';
import Secrets from '@yumi/secrets';

import { ErrorBoundary } from './ErrorBoundary';

const Legacy = React.lazy(() => import('./app'));

const Lazy: React.FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Ramen.XConfigProvider country='cl' theme='arcus' pdaSupport={Secrets.REACT_APP_PDA_SUPPORT === 'true'}>
          <Legacy />
        </Ramen.XConfigProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default Lazy;
